<template>
	<section class="page home">
		<div class="photo_wrap p-3 arrow-top-left">
			<img src="../assets/images/userPhoto.jpg" alt="">
		</div>
		<div class="image_block pos-XY-center">
			<img src="../assets/images/svg/bg_circle.svg" alt="">
		</div>
		<div class="about_me">
			<h2 class="mb-3 text-dark-blue">About Me</h2>
			<p>{{ description }}</p>
			<a :href="download" class="btn btn-white boreder border-dark text-dark rounded-0">download CV</a>
		</div>
		<h1 class="header text-dark-blue">
			<span class="d-block">{{ title }}</span>
			<span class="second-line d-block">{{ sub_title }}</span>
		</h1>
		
	</section>
</template>
<script>
export default {
	head: {
		title: {
			inner: 'about me '
		}
	},
	data () {
		return {
			id: 0,
			download: require('../assets/downloads/file.docx'),
			scrollPosition: null,
			windowWidth: 0,
			title: 'Yurii Scherbachenko',
			sub_title: "i'm a frontend developer",
			description: 'Выполняю Html-верстку (стандарты W3C, валидный код), создаю html-письма для e-mail рассылок. Разрабатываю с нуля сайты различной тематики: визитки, блоги, интернет-магазины, Landing Page и т.д., выполняю редизайн. Есть опыт кросбраузерной и адаптивной верстки.',
		}
	},
	methods: {
		getWindowWidth(event) {
			this.windowWidth = document.documentElement.clientWidth;
		},
		updateScroll: function() {
			this.scrollPosition = window.scrollY
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.getWindowWidth);
			window.removeEventListener('scroll', this.updateScroll);
		},
		onClickChild () {
			this.$emit('clicked', {
				page_id: this.id,
				next_page: '/skills',
				prev_page: false
			})
		}
	},
	mounted() {
		this.$nextTick(function() {
			window.addEventListener('resize', this.getWindowWidth);

			this.getWindowWidth()
			this.updateScroll()
			this.onClickChild()
		})
	},

}
</script>




// WEBPACK FOOTER //
// src/pages/home.vue